import {FormBuilderAnswerableScale, FormBuilderQuestion} from "@/types";
import {ExclamationCircleIcon} from '@heroicons/react/20/solid'
import AnswerableTextField from "@/Components/FormViewer/AnswerableTextField";
import {useState} from "react";

interface Props {
    question: FormBuilderQuestion,
    hasError: boolean
}

export default function AnswerableScale<T extends { answerable: FormBuilderAnswerableScale }>({
                                                                                                  question,
                                                                                                  data,
                                                                                                  setData,
                                                                                                  hasError,
                                                                                                  settings,
                                                                                              }: Props) {

    // check if the default is null and convert it to a string because React doesn't like null
    const value: string = !data[question.id] ? "" : data[question.id];
    const dropdownValue: string = (question.answerable.options.includes(value)) ? value : '_OTHER_';
    const [localValue, setLocalValue] = useState(value);
    let baseCircleClass = ' shadow-md shadow-gray-100 w-6 h-6 sm:mx-auto rounded-full mt-[-1.45rem] sm:mt-0 border border-gray-100 sm:border-transparent ';


    return (
        <div className="relative mt-1">
            <div className="justify-between items-stretch flex flex-col sm:flex-row text-sm text-gray-300 relative gap-y-2 sm:gap-y-0 ml-5 sm:ml-0">
                {question.answerable.options.map((o, index) => {
                    return (
                        <div className="flex flex-col grow shrink-0 " key={index}>
                            <button type="button" className={`hover:text-gray-600 min-w-6 w-full h-6 sm:h-auto ring-[${settings?.primaryColour}] focus-visible:outline outline-[${settings?.primaryColour}] outline-2 rounded disabled:opacity-50 disabled:cursor-not-allowed`} onClick={() => {
                                setLocalValue(o);
                                setData(question.id, o)
                            }}>
                                <div className="leading-tight text-left sm:text-center ml-8 sm:ml-0">{o}</div>
                                <div
                                    className={`${baseCircleClass} bg-[${localValue == o ? settings?.primaryColour : 'transparent'}] shadow-gray-100 ${localValue == o ? 'sm:shadow-gray-100 border-green-400' : 'sm:shadow-transparent' }`}></div>
                            </button>
                        </div>
                    );
                })}
            </div>
            <div className="hidden sm:block bg-gray-100 h-3 rounded-lg w-full -mt-[1.1rem] mb-[1.1rem]"></div>
            {(hasError) ? (errorBadge()) : (<></>)}
        </div>
    );
}

function errorBadge() {
    return (<div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
        <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true"/>
    </div>)
}

function otherAnswer(question, data, setData, value, hasError) {
    if (question.answerable.allow_other_answer && value == '_OTHER_') {
        return <AnswerableTextField question={question} data={data} setData={setData}
                                    hasError={hasError}/>
    } else {
        return <></>
    }
}
